import Style from './index.module.less'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  CommitteeElectoralStatus,
  getSendMsgTag,
  getTermsDay,
  getTransactionType,
  SendMsgTagArray,
} from '../../utils/index'
import { useTranslation } from 'react-i18next'
import MeEmpty from '@/components/MeEmpty'
import { getCommitteeElectionVoteInfo, getRestAccountAssetChangeLog } from '@/api/transactionList'
import { formatValue, ugagToGag, ugeaToGea2 } from '@/utils/number'
import classNames from 'classnames'
import useMeNavigate from '@/hooks/useMeNavigate'
import MeToolTip from '@/components/MeToolTip'
import { useParams, useSearchParams } from 'react-router-dom'
import GasFee from './gasFee'
import AddressHash from '@/components/AddressHash'
import { useGlobalStore } from '@/hoxStore/globalStore'
import {
  getFormatTimeZone,
  getLeftKuohao,
  getRightKuohao,
  isEmptyOrNil,
  navigateQueryExistsFn,
  removeDefaultZero,
} from '@/utils'
import BDSCard from './BDSCard'
import { isArray } from 'mathjs'
import { getOptions } from '@/views/Proposal/util'
import CommitteeElectionVoteInfo from './CommitteeElectionVoteInfo'
function isStringOrStringArray(value: any) {
  if (typeof value === 'boolean') value = value.toString()
  if (typeof value === 'string' || typeof value === 'number') {
    return true
  }
  if (Array.isArray(value)) {
    // 检查数组中的所有元素是否都是字符串
    return value.every((item) => typeof item === 'string') ? 'string[]' : false
  }
  return false
}

const RenderCurrentReward = ({
  valueArr,
  transactionDetail,
  type,
  noShowGag = false,
}: {
  valueArr: any
  transactionDetail: any
  type: string
  noShowGag: boolean
}) => {
  const { t } = useTranslation()
  const getLabel = (label: string, key: string) => {
    // AGE (CHN Node) 质押（存入） gea.staking.MsgCreateLockUpDelegate
    // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
    // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
    // AGD (CHN Node) 质押(存入) gea.staking.MsgCreateDelegate
    // AGS (CHN Node) 质押（30）天 gea.staking.MsgCreateFixedDelegation
    // AGS (CHN Node) 质押赎回（30）天 gea.staking.MsgWithdrawFixedDelegation
    let node = ''
    if (
      [
        'gea.staking.MsgReduceLockUpDelegation',
        'gea.staking.MsgCreateLockUpDelegate',
        'gea.staking.MsgUnDelegate',
        'gea.staking.MsgCreateDelegate',
        'gea.staking.MsgCreateFixedDelegation',
        'gea.staking.MsgWithdrawFixedDelegation',
        'gea.staking.MsgWithdrawDelegationInterest',
        'gea.staking.MsgWithdrawLockUpReward',
        'gea.staking.MsgTransferRegion',
        'gea.staking.MsgKycUsersTransferToNewRegion',
      ].includes(type)
    ) {
      if (type === 'gea.staking.MsgReduceLockUpDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.reduce_lock_up_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgCreateLockUpDelegate') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.create_lock_up_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgUnDelegate') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.undelegate?.region_id || '-'
      }
      if (type === 'gea.staking.MsgCreateDelegate') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.do_delegate?.region_id || '-'
      }
      if (type === 'gea.staking.MsgCreateFixedDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.create_fixed_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgWithdrawFixedDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.withdraw_fixed_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgWithdrawLockUpReward') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.region_id || '-'
      }
      if (type === 'gea.staking.MsgWithdrawDelegationInterest') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.withdraw_delegate_interest
            ?.region_id || '-'
      }
      //
      if (type === 'gea.staking.MsgTransferRegion') {
        if (key.includes('transaction/msgs[0]/detail/delegate_interest_info0')) {
          node =
            transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info0?.region_id ||
            '-'
        } else if (key.includes('transaction/msgs[0]/detail/delegate_interest_info1'))
          node =
            transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info1?.region_id ||
            '-'
        else node = transactionDetail?.transaction?.msgs?.[0]?.body?.to_region || '-'
      }
      if (type === 'gea.staking.MsgKycUsersTransferToNewRegion') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info.region_id || '-'
      }
    } else if (['gea.kyc.MsgUpdate'].includes(type)) {
      if (key.includes('transaction/msgs[0]/detail/delegate_interest_info0')) {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info0?.region_id ||
          '-'
      } else if (key.includes('transaction/msgs[0]/detail/delegate_interest_info1'))
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info1?.region_id ||
          '-'
      else {
        node = transactionDetail.transaction?.msgs?.[0]?.detail?.update?.belonging_region_id || ''
      }
    }
    node = node.toLocaleUpperCase()
    if (node.endsWith('_VILLAGE')) {
      node = node.replace('_VILLAGE', '').toLocaleLowerCase()
      node = node.charAt(0).toUpperCase() + node.slice(1)
    }
    if (
      [
        'gea.staking.MsgUpdateDelegatorAddress',
        'gea.staking.MsgTransferRegion',
        'gea.staking.MsgKycUsersTransferToNewRegion',
      ].includes(type)
    ) {
      const obj = {
        AGS: 'AGS_desc',
        AGD: 'AGD_desc',
        AGE: 'AGE_desc',
        AGR: 'AGR_desc',
      }
      if (['AGS', 'AGD', 'AGE', 'AGR'].includes(label)) {
        return <MeToolTip title={label} tip={t(obj[label as keyof typeof obj])}></MeToolTip>
      }
    }
    return label.replace(/\{\{[\s\S]*?\}\}/g, node)
  }

  return (
    <div className={Style.bodyWrap}>
      <div className={classNames(Style.bodyHeader, 'font_14')}>
        <div className={'font_14'}>{t('explorer_104')}</div>
        <div className={'font_14'}>
          {t('explorer_105')}
          {'(GEA)'}
        </div>
        {!noShowGag && (
          <div className={'font_14'}>
            {t('explorer_105')}
            {'(GAG)'}
          </div>
        )}
      </div>
      {valueArr.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={classNames({
              [Style.bodyItem]: true,
              [Style.bodyItemLast]: index === valueArr.length - 1,
              font_14: true,
            })}
          >
            <div className="font_14">{getLabel(item.label, item.key)}</div>
            <div className="font_14">
              {ugeaToGea2(item.value(transactionDetail, t, item.key), false, 8).value}
            </div>
            {!noShowGag && (
              <div className="font_14">
                {ugagToGag(item.value(transactionDetail, t, item.key), false, 8).value}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

function DataItem({
  item,
  transactionDetail,
  accountAssetChangeLogPromise,
  accountAssetChangeLogPromiseSingle,
  type,
  keyIndex,
  setDataItemNoneIndex,
  showAccountAssetChangeLog,
  setShowAccountAssetChangeLog,
  setShowBalanceItemGEA,
  setShowBalanceItemGAG,
}: {
  item: any
  transactionDetail: any
  accountAssetChangeLogPromise: any
  type: string
  keyIndex: number
  setDataItemNoneIndex: (index: number) => void
  accountAssetChangeLogPromiseSingle: any
  showAccountAssetChangeLog: boolean
  setShowAccountAssetChangeLog: React.Dispatch<React.SetStateAction<boolean>>
  setShowBalanceItemGEA: React.Dispatch<React.SetStateAction<boolean>>
  setShowBalanceItemGAG: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const navigate = useMeNavigate()
  const params = useParams()
  const searchParams = useSearchParams()
  const netType = searchParams[0].get('net_type') || 'hub'
  const { curReponsive } = useGlobalStore()
  const handleJump = (item: any) => {
    if (item.jumpType === '1') {
      if (
        [
          'gea.kyc.MsgAddWhiteList',
          'gea.kyc.MsgRemoveWhiteList',
          'gea.committee.MsgUpdateCommittee',
        ].includes(type)
      ) {
        if (typeof item.value === 'string') {
          navigate(`/accountDetail/${item.value}`)
        } else {
          navigate(`/accountDetail/${value}`)
        }
      } else {
        navigate(`/accountDetail/${value}`)
      }
    }
    // 国家区
    if (['6', '12'].includes(item.jumpType)) {
      // 多语言问题
      if (value.includes(t('explorer_266'))) {
        navigate(`/countryRegion/global_village`)
      } else {
        const newValue = value.endsWith('-Zone') ? value.replace('-Zone', '') : value
        navigate(`/countryRegion/${newValue.toLowerCase()}`)
      }
    }
    // 模块账户
    if (item.jumpType === '2') {
      navigate(`/moduleAccount/${value}`)
    }
    // 外部链接
    if (item.jumpType === '4') {
      if (value.includes('https://')) {
        window.open(value, '_blank')
      } else {
        window.open(`https://${value}`, '_blank')
      }
    }
    // 交易
    if (item.jumpType === '5') {
      navigate(`/transaction/${value}`)
    }
    if (item.jumpType === '3') {
      navigate(`/verifynodes/${value}`)
    }
    if (item.jumpType === '9') {
      // navigate(`/rollup/${value}`)
    }

    if (item.jumpType === '10') {
      navigate(`/proposal/${value}`)
    }
  }
  useEffect(() => {
    if (value === '-') {
      setDataItemNoneIndex(keyIndex)
    }
  }, [value])
  useEffect(() => {
    if (item.label === 'currentReward') return
    const result = item.value(transactionDetail, t)
    // 需要调用接口
    if (`${result}`.includes('account/asset-change-log')) {
      const params = new URLSearchParams(window.location.search)
      const address = params.get('address')
      if (!address) {
        setValue('-')
        return
      }
      // 控制接口值调用1次
      if (!accountAssetChangeLogPromiseSingle.current) {
        accountAssetChangeLogPromiseSingle.current = getRestAccountAssetChangeLog({
          address: address,
          tx_hash: transactionDetail.transaction?.hash,
        })
      }
      accountAssetChangeLogPromiseSingle.current.then((res: any) => {
        // 账户余额
        const allAccountValue = res?.asset_change_logs?.[0]?.after_change
        if (!allAccountValue?.length) {
          setValue('-')
          return
        }
        // 要求展示GEA
        if (result.endsWith('GEA')) {
          const geaValue = allAccountValue.find((i: any) => i.includes('ugea'))
          if (geaValue) {
            const valueObj = ugeaToGea2(geaValue)
            const str = `${valueObj.value} ${valueObj.sigin}`
            setValue(str)
            return
          }
          setValue('-')
        } else if (result.endsWith('GAG')) {
          // 要求展示GAG
          const gagValue = allAccountValue.find((i: any) => i.includes('ugag'))
          if (gagValue) {
            const valueObj = ugagToGag(gagValue)
            const str = `${valueObj.value} ${valueObj.sigin}`
            setValue(str)
            return
          }
          setValue('-')
        } else {
          // 没有特殊要求GEA
          const geaValue = allAccountValue.find((i: any) => i.includes('gea'))
          if (geaValue) {
            const valueObj = ugeaToGea2(geaValue)
            const str = `${valueObj.value} ${valueObj.sigin}`
            setValue(str)
            return
          }
          setValue('-')
        }
      })
    } else {
      if (
        // // 邀请奖励
        // item.key.endsWith('invite_reward') ||
        // // 质押数量
        // item.key.endsWith('create_lock_up_delegation/amount') ||
        // // 质押数量
        // item.key.endsWith('do_delegate/amount') ||
        // // 取回数量
        // item.key.endsWith('undelegate/amount') ||
        // // 取回数量
        // item.key.endsWith('reduce_lock_up_delegation/amount') ||
        // // 取回数量
        // item.key.endsWith('withdraw_fixed_delegation/amount')
        item.jumpType === '7' ||
        item.jumpType === '8'
      ) {
        // if (result.includes('ugea')) {
        //   const valueObj = ugeaToGea2(result)
        //   const str = `${valueObj.value} ${valueObj.sigin}`
        //   setValue(str)
        // } else {
        //   const valueObj = ugagToGag(result)
        //   const str = `${valueObj.value} ${valueObj.sigin}`
        //   setValue(str)
        // }
        console.log('result', result)
        if (result?.includes(',')) {
          const resultArr = result.split(',')
          if (item.label.includes('GEA')) {
            const item = resultArr.find((i: any) => i.includes('ugea'))
            if (item) {
              const valueObj = ugeaToGea2(item)
              const str = `${valueObj.value} ${valueObj.sigin}`
              setValue(str)
            }
          }
          if (item.label.includes('GAG')) {
            const item = resultArr.find((i: any) => i.includes('ugag'))
            if (item) {
              const valueObj = ugagToGag(item)
              const str = `${valueObj.value} ${valueObj.sigin}`
              setValue(str)
            }
          }
        } else {
          if (result?.includes('ugag') || item?.label?.includes('GAG')) {
            const valueObj = ugagToGag(result)
            const str = `${valueObj.value} ${valueObj.sigin}`
            setValue(str)
          } else {
            if (item.key.endsWith('_gea')) {
              if (isEmptyOrNil(result)) {
                setValue('-')
              } else {
                // 处理类型为gea.staking.MsgUpdateRegion 出现负数的情况
                if (['gea.staking.MsgUpdateRegion'].includes(type)) {
                  if (result.startsWith('-')) {
                    setValue('-')
                    return
                  }
                }
                const str = `${formatValue(result, true)} ${t('GEA')}`
                setValue(str)
              }
            } else {
              // ANS转GEA要*400
              if (
                // 创建和更新区
                ['gea.staking.MsgCreateRegion', 'gea.staking.MsgUpdateRegion'].includes(type) &&
                item.key === 'transaction/msgs[0]/body/region_total_stake_allow_ans'
              ) {
                // const valueObj = ugeaToGea2(result * 400)
                // const str = `${valueObj.value} ${valueObj.sigin}`
                if (result.startsWith('-')) {
                  setValue('-')
                } else {
                  const str = `${(result * 400).toLocaleString()} GEA`
                  setValue(str)
                }
              } else {
                const valueObj = ugeaToGea2(result)
                const str = `${valueObj.value} ${valueObj.sigin}`
                setValue(str)
              }
            }
          }
        }
      } else {
        if (['12', '6'].includes(item.jumpType)) {
          if (result === 'global_village') {
            setValue(t('explorer_266'))
          } else {
            if (item.jumpType === '12') {
              setValue(`${formatValue(result.toLocaleUpperCase())}-Zone`)
            } else {
              setValue(formatValue(result.toLocaleUpperCase()))
            }
          }
        } else {
          setValue(formatValue(result))
        }
      }
    }
  }, [item])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const address = params.get('address')
    const isCurrentAccount = transactionDetail?.transaction?.tx_signer?.address?.includes(address)
    if (isCurrentAccount) {
      setShowAccountAssetChangeLog(true)
    } else if (['1', '2'].includes(item.jumpType)) {
      if (
        value === address ||
        (Array.isArray(value) && value.includes(address)) ||
        transactionDetail?.tx_signer?.address?.includes(address)
      ) {
        setShowAccountAssetChangeLog(true)
      }
    }
  }, [item])

  if (item.label === 'currentReward') {
    return (
      <RenderCurrentReward
        valueArr={item.value}
        transactionDetail={transactionDetail}
        type={type}
        noShowGag={item.noShowGag}
      />
    )
  }

  if (
    ['gea.kyc.MsgAddWhiteList', 'gea.kyc.MsgRemoveWhiteList'].includes(type) &&
    item.key === 'transaction/msgs[0]/body/addresses'
  ) {
    if (!value && !value.length) return <div>-</div>
    return (
      <>
        <div className={Style.addressWrap}>
          {Array.isArray(value) &&
            (value as unknown as string[])?.map((i: any, index: number) => {
              return (
                <div className={Style.addressItem} key={index}>
                  <AddressHash
                    data={i}
                    copyIcon={'gray'}
                    handleJump={() => {
                      handleJump({
                        jumpType: '1',
                        value: i,
                      })
                    }}
                  ></AddressHash>
                </div>
              )
            })}
        </div>
      </>
    )
  }

  // if (item.jumpType === '1') {
  //   const params = new URLSearchParams(window.location.search)
  //   const address = params.get('address')
  //   // 如果当前账户是当前交易账户，则展示余额
  //   if (value === address) {
  //     setShowAccountAssetChangeLog(true)
  //   }
  // }
  // 账户余额为空不展示
  if (item.key?.includes('api/rest/account/asset-change-log')) {
    if (value === '-' || isEmptyOrNil(value)) {
      if (item.label.includes('GEA')) {
        setShowBalanceItemGEA(false)
      } else if (item.label.includes('GAG')) {
        setShowBalanceItemGAG(false)
      }
      return null
    } else {
      if (item.label.includes('GEA')) {
        setShowBalanceItemGEA(true)
      } else if (item.label.includes('GAG')) {
        setShowBalanceItemGAG(true)
      }
    }
    if (!showAccountAssetChangeLog) return null
  }

  const renderValue = ({
    value,
    type,
    jumpType,
  }: {
    value: string
    type: string
    jumpType: string
  }) => {
    if (
      type === 'ibc.core.client.v1.MsgUpdateClient' &&
      item.key === 'transaction/msgs[0]/body/client_id' &&
      netType === 'rollup'
    ) {
      return transactionDetail.tx?.[0]?.msgs?.[0]?.body?.client_id || '-'
    }
    if (jumpType === '11') {
      const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(value)
      return (
        <div className={Style.timeWrap}>
          <div className={Style.timeItem}>
            <span>{timeUtc0}</span>
            <span className="opacity_5">
              {getLeftKuohao(curReponsive)}
              {'UTC+0'}
              {getRightKuohao(curReponsive)}
            </span>
          </div>
          <div className={Style.timeItem}>
            <span>{currentTime}</span>
            <span className="opacity_5">
              {getLeftKuohao(curReponsive)}
              {t('explorer_95')}
              {getRightKuohao(curReponsive)}
            </span>
          </div>
        </div>
      )
    }
    if (
      ['gea.staking.MsgUpdateRegion', 'gea.staking.MsgCreateRegion'].includes(type) &&
      [
        'transaction/msgs[0]/body/lock_up_interest_term',
        'transaction/msgs[0]/body/lock_up_principal_term',
      ].includes(item.key)
    ) {
      return `${value} ${t('explorer_225')}`
    }
    if (
      type === 'gea.committee.MsgEndProposal' &&
      item.key === 'transaction/msgs[0]/detail/end_proposal/status'
    ) {
      if (value === 'end') return t('explorer_292')
      return value
    }
    if (
      ['gea.committee.MsgEndElectoral', 'gea.committee.MsgStartElectoral'].includes(type) &&
      item.key === 'transaction/msgs[0]/detail/status'
    ) {
      if (CommitteeElectoralStatus[value as keyof typeof CommitteeElectoralStatus]) {
        return t(CommitteeElectoralStatus[value as keyof typeof CommitteeElectoralStatus])
      }
      return value
    }
    if (type === 'gea.kyc.MsgStar') {
      return <div className={Style.star}>{`${value} ${t('explorer_285')}`}</div>
    }
    if (
      type === 'gea.committee.MsgVoteProposal' &&
      item.key === 'transaction/msgs[0]/body/is_support'
    ) {
      if (value) return t('explorer_286')
      return t('explorer_287')
    }
    if (
      type === 'gea.rollapp.MsgCreateRollapp' &&
      item.key === 'transaction/msgs[0]/body/permissionedAddresses'
    ) {
      if (!value.length) return '-'
      return (
        <div className={Style.addressWrap}>
          {(value as unknown as string[]).map((i: any, index: number) => {
            return (
              <div className={Style.addressItem} key={index}>
                <AddressHash
                  data={i}
                  copyIcon={'gray'}
                  handleJump={() => {
                    navigateQueryExistsFn(i, navigate)
                  }}
                ></AddressHash>
              </div>
            )
          })}
        </div>
      )
    }
    // 移除数字0
    const geaStakingMsgSetSwapRateFlag =
      type === 'gea.staking.MsgSetSwapRate' && item.key === 'transaction/msgs[0]/detail/swap_rate'
    const geaStakingMsgCreateRegionFlag =
      ['gea.staking.MsgUpdateRegion', 'gea.staking.MsgCreateRegion'].includes(type) &&
      [
        'transaction/msgs[0]/body/region_total_ans',
        'transaction/msgs[0]/body/lock_up_rate',
        'transaction/msgs[0]/body/region_fee_rate',
      ].includes(item.key)
    const geaStakingMsgSetFixedDelegationInterestRate =
      type === 'gea.staking.MsgSetFixedDelegationInterestRate' &&
      item.key === 'transaction/msgs[0]/body/rate'
    if (
      geaStakingMsgSetSwapRateFlag ||
      geaStakingMsgCreateRegionFlag ||
      geaStakingMsgSetFixedDelegationInterestRate
    ) {
      if (isEmptyOrNil(value)) {
        return '-'
      }
      return removeDefaultZero(value)
    }

    if (
      type === 'gea.staking.MsgSetFixedDelegationInterestRate' &&
      item.key === 'transaction/msgs[0]/body/deposit_peiod'
    ) {
      return getTermsDay(value) + ' ' + t('explorer_225')
    }
    if (type === 'cosmos.gov.v1beta1.MsgSubmitProposal') {
      if (item.key === 'transaction/msgs[0]/body/content/@type') return t('explorer_280')
      if (item.key === 'voting_start_time') {
        if (value === '-') return '-'
        const { timeUtc0 = '-', currentTime = '-' } = getFormatTimeZone(value)
        return (
          <div className={Style.timeWrap}>
            <div className={Style.timeItem}>
              <span>{timeUtc0}</span>
              <span className="opacity_5">
                {getLeftKuohao(curReponsive)}
                {'UTC+0'}
                {getRightKuohao(curReponsive)}
              </span>
            </div>
            <div className={Style.timeItem}>
              <span>{currentTime}</span>
              <span className="opacity_5">
                {getLeftKuohao(curReponsive)}
                {t('explorer_95')}
                {getRightKuohao(curReponsive)}
              </span>
            </div>
          </div>
        )
      }
    }
    if (
      type === 'gea.committee.MsgUpdateCommittee' &&
      [
        'transaction/msgs[0]/body/addresses_to_add',
        'transaction/msgs[0]/body/addresses_to_remove',
      ].includes(item.key)
    ) {
      if (isEmptyOrNil(value) || !isArray(value) || value?.length === 0)
        return <span className="emptyDataSpan">-</span>
      return (
        <div className={Style.addressWrap}>
          {Array.isArray(value) &&
            (value as unknown as string[])?.map((i: any, index: number) => {
              return (
                <div className={Style.addressItem} key={index}>
                  <AddressHash
                    data={i}
                    copyIcon={'gray'}
                    handleJump={() => {
                      handleJump({
                        jumpType: '1',
                        value: i,
                      })
                    }}
                  ></AddressHash>
                </div>
              )
            })}
        </div>
      )
    }
    if (type === 'cosmos.gov.v1beta1.MsgVote' && item.key === 'transaction/msgs[0]/body/option') {
      return getOptions(value, t)
    }

    if (typeof value === 'string' && (value?.endsWith('GEA') || value?.endsWith('GAG'))) {
      const valueArr = value.split(' ')
      return (
        <div>
          <span>{valueArr?.[0]}</span>
          <span className="opacity_5" style={{ marginLeft: '4px' }}>
            {valueArr?.[1]}
          </span>
        </div>
      )
    }
    return value
  }
  const renderSpecialTypeValue = ({ value, type }: { value: string; type: string }) => {
    if (type === 'gea.rollapp.MsgUpdateState' && item.key === 'transaction/msgs[0]/body/BDs/BD') {
      return (
        <div className={Style.updateStateBDsWrap}>
          {(value as unknown as any[]).map((i: any) => {
            return <BDSCard key={i.height} cardData={i}></BDSCard>
          })}
        </div>
      )
    }
    return '-'
  }
  return (
    <div
      onClick={() => {
        if (value !== '-') {
          handleJump(item)
        }
      }}
      className={classNames({
        [Style.link]:
          item.jumpType && value !== '-' && !['7', '8', '11', '9'].includes(item.jumpType),
        [Style.renderItemContent]: true,
        [Style.breakWord]: item.key === 'transaction/msgs[0]/body/DAPath',
      })}
    >
      {/* 判断是不是react元素 */}
      {isStringOrStringArray(value)
        ? ['1', '2', '3'].includes(item.jumpType)
          ? (() => {
              if (
                type === 'ibc.core.client.v1.MsgUpdateClient' &&
                item.key === 'transaction/msgs[0]/body/signer' &&
                netType === 'rollup'
              ) {
                const value = transactionDetail.tx?.[0]?.msgs?.[0]?.body?.signer || '-'
                return (
                  <AddressHash
                    data={value}
                    copyIcon={'gray'}
                    handleJump={() => {
                      navigate(`/accountDetail/${value}`)
                    }}
                  ></AddressHash>
                )
              }
              return (
                <AddressHash
                  data={value}
                  copyIcon={item.jumpType === '3' ? '' : 'gray'}
                ></AddressHash>
              )
            })()
          : renderValue({ value, type, jumpType: item.jumpType })
        : renderSpecialTypeValue({ value, type })}
    </div>
  )
}

const CardInfoThree = ({
  style = {},
  transactionDetail,
  showGasFee,
  accountAssetChangeLogPromiseSingle,
  getCommitteeElectionVoteInfoPromise,
}: {
  style?: React.CSSProperties
  transactionDetail: { [key: string]: any }
  showGasFee: boolean
  accountAssetChangeLogPromiseSingle: any
  getCommitteeElectionVoteInfoPromise: any
}) => {
  const searchParams = useSearchParams()
  const netType = searchParams[0].get('net_type') || 'hub'
  const [committeeElectionVoteInfo, setCommitteeElectionVoteInfo] = useState<any>(null)
  const [committeeElectionVoteInfoLoading, setCommitteeElectionVoteInfoLoading] =
    useState<boolean>(false)
  const { curReponsive } = useGlobalStore()
  const [noneIndex, setNoneIndex] = useState<number>(-1)
  // 是否展示余额，不是和当前账户相关的不展示
  const [showAccountAssetChangeLog, setShowAccountAssetChangeLog] = useState<boolean>(false)
  const [showBalanceItemGEA, setShowBalanceItemGEA] = useState<boolean>(true)
  const [showBalanceItemGAG, setShowBalanceItemGAG] = useState<boolean>(true)
  console.log()

  let type = ''
  if (netType === 'hub') {
    type = transactionDetail?.transaction?.msgs?.[0]?.type || ''
  } else {
    type = transactionDetail?.tx?.[0]?.msgs?.[0]?.type || ''
    // type = transactionDetail?.transaction?.messages?.[0]['@type'] || ''
    // if (type.startsWith('/')) {
    //   type = type.slice(1)
    // }
  }

  const { t } = useTranslation()
  // gea.bank.MsgModuleAccountSend 转账
  const { pageTitle, pageKeyList, pageKeyListOther } = getTransactionType(type, transactionDetail)!
  const accountAssetChangeLogPromise = useRef<any>(null)

  const handleRender = ({
    accountAssetChangeLogPromise,
    list,
    accountAssetChangeLogPromiseSingle,
    showAccountAssetChangeLog,
    setShowAccountAssetChangeLog,
  }: {
    accountAssetChangeLogPromise: any
    accountAssetChangeLogPromiseSingle: any
    list: any[]
    showAccountAssetChangeLog: boolean
    setShowAccountAssetChangeLog: React.Dispatch<React.SetStateAction<boolean>>
  }) => {
    const params = new URLSearchParams(window.location.search)
    const address = params.get('address')
    if (!address) {
      list = list.filter((item: any) => {
        return !item?.key?.includes('rest/account/asset-change-log')
      })
    }
    const getLabel = (label: string, item: any) => {
      if (label === 'currentReward') {
        if (
          [
            'gea.staking.MsgTransferRegion',
            'gea.staking.MsgKycUsersTransferToNewRegion',
            'gea.staking.MsgUpdateDelegatorAddress',
          ].includes(type)
        ) {
          return <span>{item.labelTwo ? t(item.labelTwo) : t('explorer_289')}:</span>
        }
        return <MeToolTip title={t('explorer_247')} tip={t(item.tip)}></MeToolTip>
      }
      if (item.key === 'transaction/msgs[0]/detail/common_region_transfer/kyc_reward') {
        return <span>{t('explorer_288')}:</span>
      }
      // AGS (CHN Node) 质押赎回（30）天 gea.staking.MsgWithdrawFixedDelegation
      if (['gea.staking.MsgWithdrawFixedDelegation'].includes(type)) {
        let node =
          transactionDetail.transaction?.msgs?.[0]?.detail?.delegate_interest_info?.region_id || '-'

        node = node.toLocaleUpperCase()
        if (node.endsWith('_VILLAGE')) {
          node = node.replace('_VILLAGE', '').toLocaleLowerCase()
          node = node.charAt(0).toUpperCase() + node.slice(1)
        }

        const replacedText = label.replace(
          /\{\{(.*?)\}\}/g, // 匹配 {{ ... }}
          (match, content) => {
            if (/regionId/.test(content)) {
              return node // {{ ... regionId ... }}
            }
            //  else if (/term/.test(content)) {
            //   return getTermsDay(term) // {{ ... term ... }}
            // }
            return match // 其他情况保持不变
          },
        )
        return replacedText
      }
      // 是否需要显示余额
      if (item?.key?.includes('rest/account/asset-change-log')) {
        if (item.label.includes('GEA') && !showBalanceItemGEA) {
          return null
        } else if (item.label.includes('GAG') && !showBalanceItemGAG) {
          return null
        }
        if (showAccountAssetChangeLog) {
          return <span>{label}:</span>
        }
        return null
      }
      return <span>{label}:</span>
    }

    // 需要不展示的索引
    const setDataItemNoneIndex = (index: number) => {
      setNoneIndex(index)
    }
    const val = list.map((item: any, index: number) => {
      const AddressItemWrapFlag1 =
        ['gea.kyc.MsgAddWhiteList', 'gea.kyc.MsgRemoveWhiteList'].includes(type) &&
        item.key === 'transaction/msgs[0]/body/addresses'
      const AddressItemWrapFlag2 =
        ['gea.committee.MsgUpdateCommittee'].includes(type) &&
        [
          'transaction/msgs[0]/body/addresses_to_add',
          'transaction/msgs[0]/body/addresses_to_remove',
        ].includes(item.key)
      return (
        <div
          className={classNames({
            [Style.item]: true,
            [Style.itemNoneItem]:
              (!showAccountAssetChangeLog || noneIndex === index) &&
              item?.key?.includes('rest/account/asset-change-log'),
            [Style.itemCurrentTable]: item.label === 'currentReward',

            [Style.msgAddWhiteListAddressItem]:
              (AddressItemWrapFlag1 || AddressItemWrapFlag2) && curReponsive?.size === 'mobile',
            [Style.MsgUpdateStateBDs]:
              type === 'gea.rollapp.MsgUpdateState' &&
              item.key === 'transaction/msgs[0]/body/BDs/BD',
          })}
          key={index}
        >
          <span
            className={classNames({
              [Style.itemLabelCurrentReward]: item.label === 'currentReward',
              [Style.msgAddWhiteListAddress]: AddressItemWrapFlag1 || AddressItemWrapFlag2,
              [Style.itemNone]:
                item?.key?.includes('api/rest/account/asset-change-log') && noneIndex === index,
              font_14: true,
              [Style.showLabelNone]: item.showLabelNone,
            })}
          >
            {getLabel(item.label, item)}
          </span>
          <div className={classNames(Style.itemLabelCurrentRewardContent, 'font_14')}>
            <DataItem
              item={item}
              setShowBalanceItemGEA={setShowBalanceItemGEA}
              setShowBalanceItemGAG={setShowBalanceItemGAG}
              keyIndex={index}
              transactionDetail={transactionDetail}
              accountAssetChangeLogPromise={accountAssetChangeLogPromise}
              accountAssetChangeLogPromiseSingle={accountAssetChangeLogPromiseSingle}
              type={type}
              setDataItemNoneIndex={setDataItemNoneIndex}
              showAccountAssetChangeLog={showAccountAssetChangeLog}
              setShowAccountAssetChangeLog={setShowAccountAssetChangeLog}
            ></DataItem>
          </div>
        </div>
      )
    })
    return val
  }

  const pageTitleFormat = useMemo(() => {
    // 轉賬特殊類型處理
    if (type === 'cosmos.bank.v1beta1.MsgSend') {
      const tag = transactionDetail?.transaction.tag
      if (SendMsgTagArray.includes(tag)) {
        return getSendMsgTag(tag, t)
      }
    }
    // AGE (CHN Node) 质押（存入） gea.staking.MsgCreateLockUpDelegate
    // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
    // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
    // AGD (CHN Node) 质押(存入) gea.staking.MsgCreateDelegate
    // AGS（{{ regionId }}  Node ）质押（{{ term }} 天） gea.staking.MsgCreateFixedDelegation
    // AGS（{{ regionId }} Node）赎回 gea.staking.MsgWithdrawFixedDelegation
    // AGE ({{ regionId }} Node)提取锁仓奖励 gea.staking.MsgWithdrawLockUpReward
    let node = ''
    if (
      [
        'gea.staking.MsgReduceLockUpDelegation',
        'gea.staking.MsgCreateLockUpDelegate',
        'gea.staking.MsgUnDelegate',
        'gea.staking.MsgCreateDelegate',
        'gea.staking.MsgCreateFixedDelegation',
        'gea.staking.MsgWithdrawFixedDelegation',
        'gea.staking.MsgWithdrawLockUpReward',
      ].includes(type)
    ) {
      // let node =
      //   transactionDetail.transaction?.msgs?.[0]?.detail?.delegate_interest_info
      //     ?.region_id || '-'

      if (type === 'gea.staking.MsgReduceLockUpDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.reduce_lock_up_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgCreateLockUpDelegate') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.create_lock_up_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgUnDelegate') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.undelegate?.region_id || '-'
      }
      if (type === 'gea.staking.MsgCreateDelegate') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.do_delegate?.region_id || '-'
      }
      if (type === 'gea.staking.MsgCreateFixedDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.create_fixed_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgWithdrawFixedDelegation') {
        node =
          transactionDetail?.transaction?.msgs?.[0]?.detail?.withdraw_fixed_delegation?.region_id ||
          '-'
      }
      if (type === 'gea.staking.MsgWithdrawLockUpReward') {
        node = transactionDetail?.transaction?.msgs?.[0]?.detail?.region_id || '-'
      }
      let term = ''
      if (type === 'gea.staking.MsgCreateFixedDelegation') {
        term =
          transactionDetail.transaction?.msgs?.[0]?.detail?.create_fixed_delegation
            ?.fixed_deposit_period || ''
      }
      if (type === 'gea.staking.MsgWithdrawFixedDelegation') {
        term =
          transactionDetail.transaction?.msgs?.[0]?.detail?.withdraw_fixed_delegation
            ?.fixed_deposit_period || ''
      }

      node = node.toLocaleUpperCase()
      if (node.endsWith('_VILLAGE')) {
        node = node.replace('_VILLAGE', '').toLocaleLowerCase()
        node = node.charAt(0).toUpperCase() + node.slice(1)
      }
      const replacedText = pageTitle.replace(
        /\{\{(.*?)\}\}/g, // 匹配 {{ ... }}
        (match, content): any => {
          if (/regionId/.test(content)) {
            return node // {{ ... regionId ... }} → aa
          } else if (/term/.test(content)) {
            return getTermsDay(term) // {{ ... term ... }} → bb
          }
          return match // 其他情况保持不变
        },
      )
      if (node === '-' && replacedText.includes('Node')) {
        const newPageTitle = replacedText.replace(/(\s*Node\s*)/, '')
        return newPageTitle
      }
      return replacedText
    }
    return pageTitle
  }, [type, pageTitle])

  useEffect(() => {}, [showAccountAssetChangeLog])

  const getMsgWithdrawFixedDelegation = () => {
    let node =
      transactionDetail.transaction?.msgs?.[0]?.detail?.delegate_interest_info?.region_id || '-'
    node = node.toLocaleUpperCase()
    if (node.endsWith('_VILLAGE')) {
      node = node.replace('_VILLAGE', '').toLocaleLowerCase()
      node = node.charAt(0).toUpperCase() + node.slice(1)
    }
    return t('explorer_260').replace('{{ regionId }}', node)
  }

  const noNeedGasFeeType: string[] = [
    // 'gea.staking.MsgTransferRegion',
    // 'gea.committee.MsgStartElectoral',
    // 'cosmos.gov.v1beta1.MsgSubmitProposal',
    // 'cosmos.gov.v1beta1.MsgVote',
    // 'gea.committee.MsgEndElectoral',
  ]

  const getCommitteeElectionVoteInfoFn = () => {
    const electoral_id = transactionDetail?.transaction?.msgs?.[0]?.body?.electoral_id
    if (!electoral_id || committeeElectionVoteInfoLoading) return
    if (!getCommitteeElectionVoteInfoPromise.current) {
      setCommitteeElectionVoteInfoLoading(true)
      getCommitteeElectionVoteInfoPromise.current = getCommitteeElectionVoteInfo({
        election_id: Number(electoral_id),
        limit: 50,
        offset: 0,
      })
    }
    getCommitteeElectionVoteInfoPromise.current.then((res: any) => {
      setCommitteeElectionVoteInfo(res)
      setCommitteeElectionVoteInfoLoading(false)
    })
  }

  useEffect(() => {
    getCommitteeElectionVoteInfoFn()
  }, [])

  if (!type) return <MeEmpty></MeEmpty>
  return (
    <div>
      <div style={{ ...style }} className={Style.wrap}>
        <div className={Style.item}>
          <span>
            {t('explorer_104')}
            <span style={{ marginLeft: '2px' }}>:</span>
          </span>
          <div className={Style.textStyleOne}>{pageTitleFormat}</div>
        </div>
        {handleRender({
          accountAssetChangeLogPromise: accountAssetChangeLogPromise,
          list: pageKeyList,
          accountAssetChangeLogPromiseSingle,
          showAccountAssetChangeLog,
          setShowAccountAssetChangeLog,
        })}
        {/* GasFee分配 */}
        {transactionDetail?.transaction?.gas_fee?.receivers?.length &&
        showGasFee &&
        !noNeedGasFeeType.includes(type) ? (
          <GasFee receivers={transactionDetail.transaction?.gas_fee?.receivers}></GasFee>
        ) : null}
        {type === 'gea.committee.MsgEndElectoral' ? (
          <CommitteeElectionVoteInfo
            type={type}
            data={committeeElectionVoteInfo}
            loading={committeeElectionVoteInfoLoading}
          ></CommitteeElectionVoteInfo>
        ) : null}
      </div>
      {pageKeyListOther.length ? (
        <div className={Style.wrap}>
          {type === 'gea.staking.MsgWithdrawFixedDelegation' ? (
            <div className={Style.textStyleOne}>{getMsgWithdrawFixedDelegation()}</div>
          ) : null}
          {handleRender({
            accountAssetChangeLogPromise: accountAssetChangeLogPromise,
            list: pageKeyListOther,
            accountAssetChangeLogPromiseSingle,
            showAccountAssetChangeLog,
            setShowAccountAssetChangeLog,
          })}
        </div>
      ) : null}
    </div>
  )
}

export default CardInfoThree
